<template>
  <a-modal
    v-model="visible"
    title="推送产品库"
    width="700px"
    destroyOnClose
    @ok="ok"
    @cancel="cancel"
    class="noMargin"
  >
    <a-space slot="footer">
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" @click="ok" :loading="btnLoading">确定</a-button>
    </a-space>
    <a-form :form="form"  :label-col="{ span: 4 }" :wrapper-col="{ span: 15 }">
      <a-form-item label="产品名称">
        {{rowData.productName}}
      </a-form-item>
      <a-form-item label="配方类型">
        {{formulaType(rowData.formulaType)}}
      </a-form-item>
      <a-form-item label="配方代码">
        {{rowData.formulaCode}}
      </a-form-item>
      <a-form-item label="版本">
        {{rowData.version}}
      </a-form-item>
      <a-form-item label="EBS名称">
        <a-input
          v-decorator="['ebsMaterial']"
          placeholder="请输入EBS名称"
        />
      </a-form-item><a-form-item label="EBS编码">
        <a-input
          v-decorator="['ebsMaterialCode']"
          placeholder="请输入EBS编码"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
export default {
  props: ['visible','rowData'],
  data() {
    return {
      form: this.$form.createForm(this),
      btnLoading: false,
    };
  },
  methods: {
    formulaType(formulaType){
      let str = ''
      if(formulaType === 1) str = '配合饲料'
      if(formulaType === 2) str = '混合日粮'
      if(formulaType === 3) str = 'TMR'
      if(formulaType === 4) str = '定制料'
      return str
    },
    ok(){
      this.form.validateFields((err, values) => {
        if(!err){
          let data = {
            productId: this.rowData.id,
            ...this.rowData,...values
          }
          delete data.id
          delete data.pushTime
          delete data.pushReturnTime
          this.btnLoading = true
          this.$http.post('/nhf-custom/customprolib/pushToProLib',data).then(res => {
            let {success,msg} = res || {}
            let msgFeild = 'warning'
            if(success) msgFeild = 'success'
            this.$message[msgFeild](msg)
            this.$emit('close',true)
          }).finally(() => {
            this.btnLoading = false
          })
        }
      })
    },
    cancel(){
      this.$emit('close',false)
    },
  },
};
</script>
<style lang="scss">
  .noMargin{
    .ant-form-item{
      margin-bottom: 0px;
    }
  }
</style>